import { render, staticRenderFns } from "./FeaturesTab.vue?vue&type=template&id=62603599&scoped=true"
import script from "./FeaturesTab.vue?vue&type=script&lang=js"
export * from "./FeaturesTab.vue?vue&type=script&lang=js"
import style0 from "./FeaturesTab.vue?vue&type=style&index=0&id=62603599&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62603599",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62603599')) {
      api.createRecord('62603599', component.options)
    } else {
      api.reload('62603599', component.options)
    }
    module.hot.accept("./FeaturesTab.vue?vue&type=template&id=62603599&scoped=true", function () {
      api.rerender('62603599', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/features-tab/FeaturesTab.vue"
export default component.exports